package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.model.Invitation
import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class GetPendingTeamCreationInvitationUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(childId: String): Result<Invitation?> =
        invitationService.getPendingTeamCreationInvitation(childId)
}
